import React, { useEffect, useState } from "react";
import CoursesList from "../component/coursesList/coursesList";
import LmsHeader from "../component/lmsHeader/lmsHeader";
import {
  CREATE_COURSE,
  COURSES,
  LESSON,
  ACCESS_DENIED,
  COURSES_SCORM,
} from "../../../constant/routeContant";
import { useSelector, useDispatch } from "react-redux";
import * as lmsAction from "../../../redux/actions/lmsAction";
import {
  PAGE_SIZE,
  ORG_ID,
  USER_ID,
  API_STATUS,
} from "../../../constant/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../../library/common/Loader";

const CoursesContainer = () => {
  const dispatch = useDispatch();
  const CoursedeleteStatus = useSelector((state) => state.deleteCourse.status);
  const [sendEmail, setSendEmail] = useState(false);
  const [publicStatus, setPublicStatus] = useState(false);

  const courseListData = useSelector((state) => state.getCoursesList);
  const publishCourseStatus = useSelector(
    (state) => state.publishCourse.status
  );
  const publishCourseDetail = useSelector((state) => state.publishCourse);
  const [isdisable, setisdisable] = useState(false);
  const [iscloneBtnClick, setIscloneBtnClick] = useState(false);
  const cloneCourseData = useSelector((state) => state.cloneCourseData);
  const publishCourses = async (data) => {
    setisdisable(true);
    dispatch(lmsAction.publishCourse(data));
  };
  const location = useLocation();
  let navigate = useNavigate();
  const [defaultCourseTab] = useState(() =>
    location?.state?.defaultCourseTab !== undefined
      ? location.state.defaultCourseTab
      : 0
  );
  const dataHeader = {
    title: "Training Management",

    btnLink: CREATE_COURSE,
    menu: [
      {
        route: LESSON,
        text: "Lessons",
      },
      {
        route: COURSES,
        text: "Courses",
      },
      {
        route: COURSES_SCORM,
        text: "Marketplace",
      },
    ],
  };
  if (checkPrivileges([12, 11])) {
    dataHeader.btnText = "Create Course";
  }
  const defaultData = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    userId: USER_ID(),
    organisationId: ORG_ID(),
    status: defaultCourseTab === 0 ? "" : defaultCourseTab,
    isSendMail: false,
  };
  const categoryListData = useSelector((state) => state.getCategoryList?.data);

  const showLoader = useSelector(
    (state) =>
      state.getCategoryList?.isLoading ||
      state.cloneCourseData?.isLoading ||
      state.publishCourse?.isLoading
  );

  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10]);

    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    getCoursesListData(defaultData);
    dispatch(lmsAction.clearPublishCourse());
    dispatch(lmsAction.clearCategoryList());
    dispatch(lmsAction.clearDeleteLesson(""));
  }, []);

  useEffect(() => {
    if (location?.state?.defaultCourseTab !== undefined) {
      const { defaultCourseTab: _defaultCourseTab, ...rest } =
        location.state ?? {};
      navigate(location.pathname, {
        replace: true,
        state: Object.keys(rest).length ? rest : null,
      });
    }
  }, [location?.state, location?.pathname, navigate]);

  const getCoursesListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(lmsAction.getCoursesList(data));
  };
  const getategoryListData = (data) => {
    dispatch(lmsAction.getCategoryList(data));
  };
  const deleteCourse = (data) => {
    dispatch(lmsAction.deleteCourse(data));
  };

  useEffect(() => {
    if (courseListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Courses has been sent to registered email ID");
    }
  }, [courseListData]);

  const cloneCourse = (data) => {
    setIscloneBtnClick(true);
    dispatch(lmsAction.cloneCourse(data));
  };
  useEffect(() => {
    if (
      publishCourseDetail?.data?.responseMessages?.responseCode === "HBNG017" &&
      publicStatus
    ) {
      toast(publishCourseDetail?.data?.responseMessages?.responseMessage);
    }
  }, [publishCourseDetail]);

  return (
    <>
      {showLoader && <Loader />}
      <LmsHeader dataHeader={dataHeader} />
      <ToastContainer />
      <CoursesList
        onSubmit={publishCourses}
        CoursedeleteStatus={CoursedeleteStatus}
        publishCourseStatus={publishCourseStatus}
        courseListData={courseListData}
        getCoursesListData={getCoursesListData}
        categoryListData={categoryListData}
        deleteCourse={deleteCourse}
        setisdisable={setisdisable}
        isdisable={isdisable}
        cloneCourse={cloneCourse}
        cloneCourseData={cloneCourseData}
        toast={toast}
        iscloneBtnClick={iscloneBtnClick}
        setIscloneBtnClick={setIscloneBtnClick}
        setPublicStatus={setPublicStatus}
        getategoryListData={getategoryListData}
        tableClass={"increaseHeight"}
        defaultTabValue={defaultCourseTab}
      />
    </>
  );
};

export default CoursesContainer;
